import type { AnnotationT, CuboidDataT, MetaDataT } from '../../../../types';
export const boundCoordinate = (annotation: AnnotationT, metadata: MetaDataT): AnnotationT => {
  switch (annotation.annotationType) {
    case 'CUBOID':
      {
        return {
          ...annotation,
          data: {
            points: (annotation.data.points.map(([x, y]) => ([boundX(x, metadata), boundY(y, metadata)] as const)) as CuboidDataT['points'])
          }
        };
      }
    case 'ELLIPSE':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            centerX: boundX(annotation.data.centerX, metadata),
            centerY: boundY(annotation.data.centerY, metadata)
          }
        };
      }
    case 'POLYGON':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            points: annotation.data.points.map(([x, y]) => ([boundX(x, metadata), boundY(y, metadata)] as const))
          }
        };
      }
    case 'POLYLINE':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            points: annotation.data.points.map(([x, y]) => ([boundX(x, metadata), boundY(y, metadata)] as const))
          }
        };
      }
    case 'RECTANGLE':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            x: boundX(annotation.data.x, metadata),
            y: boundY(annotation.data.y, metadata),
            width: annotation.data.x < 0 ? annotation.data.width + annotation.data.x : annotation.data.width,
            height: annotation.data.y < 0 ? annotation.data.height + annotation.data.y : annotation.data.height
          }
        };
      }
    case 'SKELETON':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            nodes: annotation.data.nodes.map(node => ({
              ...node,
              point: [boundX(node.point[0], metadata), boundY(node.point[1], metadata)]
            }))
          }
        };
      }
    case 'KEY_POINT':
      {
        return {
          ...annotation,
          data: {
            ...annotation.data,
            x: boundX(annotation.data.x, metadata),
            y: boundY(annotation.data.y, metadata)
          }
        };
      }
    // Frame classification does not a coordinate.
    case 'FRAME_CLASSIFICATION':
    // Segmentation will never be out of bound of an image.
    case 'SEGMENTATION':
      return annotation;
  }
};
const boundX = (x: number, metadata: MetaDataT) => {
  if (x < 0) {
    return 0;
  }
  if (x > metadata.width) {
    return metadata.width;
  }
  return x;
};
const boundY = (y: number, metadata: MetaDataT) => {
  if (y < 0) {
    return 0;
  }
  if (y > metadata.height) {
    return metadata.height;
  }
  return y;
};